import { useSelector } from "react-redux";
import { ApplicationState } from "../rootStore";

export const useBillingAddressReducer = () => useSelector((state: ApplicationState) => state.billingAddress);
